import { Http } from "../Http";
import { MissingAppointmentsDto } from "../../../Api/Model/MissingAppointments/MissingAppointmentsDto.csharp";

export interface IMissingAppointmentsApi {
  get(
    serviceId: string,
    relatedServiceIds: number[]
  ): Promise<MissingAppointmentsDto>;
}

export class MissingAppointmentsApi implements IMissingAppointmentsApi {
  public get = (
    serviceId: string,
    relatedServiceIds: number[]
  ): Promise<MissingAppointmentsDto> => {
    return Http.post(
      `/api/services/${serviceId}/appointments/missing`,
      relatedServiceIds
    ) as Promise<MissingAppointmentsDto>;
  };
}
